import React from 'react';
import ReactDOM from 'react-dom';

import { ThemeProvider, Styled, useColorMode } from 'theme-ui';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import App from './App';
import * as serviceWorker from './serviceWorker';
import theme from './theme';
import { withApollo, withAuth } from 'hocs';
import OnlineStatusProvider from 'contexts/OnlineStatusProvider';
import get from 'lodash.get';
import merge from 'lodash.merge';
import IdentityProvider from 'contexts/IdentityProvider';

const Index: React.FC = () => {
  return (
    <IdentityProvider>
      <OnlineStatusProvider>
        <ThemeProvider theme={theme}>
          <StyledRoot theme={theme}>
            <Styled.root>
              <App />
            </Styled.root>
          </StyledRoot>
        </ThemeProvider>
      </OnlineStatusProvider>
    </IdentityProvider>
  );
};

const StyledRoot: React.FC<{ theme: Theme }> = ({ theme, children }) => {
  const [mode] = useColorMode();

  const styledTheme = merge({}, theme, {
    colors: get(theme.colors.modes, mode, theme.colors)
  });

  return (
    <StyledThemeProvider theme={styledTheme}>{children}</StyledThemeProvider>
  );
};

const EnhancedIndex = withAuth(withApollo(Index));

ReactDOM.render(<EnhancedIndex />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
